<template>
  <div class="timeline">
    <div id="chart"/>
  </div>
</template>

<script>
import * as d3 from "d3";

export default {
  name: 'TimelineVis',
  props: {
    event_items: Array
  },
  mounted() {
    let events = this.processData(this.event_items);
    this.generateTimeline(events);
  },
  methods: {
    processData(events) {
      if (events.length > 0) {
        events[0].row = 0;
      }

      for (let i = 1; i < events.length; i++) {
        let row_list = [...new Set(events.slice(0, i).map(a => a.row))];

        for (let r in row_list) {
          let events_in_row = events.slice(0, i).filter(a => (a.row == row_list[r]));
          let intersect = false;

          for (let e in events_in_row) {
            if ((events[i].startDate <= events_in_row[e].endDate) && (events_in_row[e].startDate <= events[i].endDate)) {
              intersect = true;
            }
          }

          if (intersect == false) {
            events[i].row = r;
            break;
          }
        }

        if (!events[i].row) {
          events[i].row = Math.max(...row_list) + 1;
        }
      }

      return events;
    },
    generateTimeline(events) {
      // log data for debugging
      // console.log(events);

      const w = 900;
      const h = 300;

      const vis = d3.select('#chart')
        .data(events)
        .append('svg')
        .attr("viewBox", '-10 0 1000 480')
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr('background-color','#c3faf8')
        .attr("transform", "translate("+20+"," + 0 + ")")
          .append('g');




     var latestDate = d3.max(events, d => d.endDate); // finds latest date from data
     var earliestDate = d3.min(events, d => d.startDate); // finds earliest data from data

      //scale for timeline along bottom
      var timeScale = d3.scaleTime()
        .domain([earliestDate, latestDate])
        .range([0, 800]);


      var locationColor = d3.scaleOrdinal().domain(events)

        .range(["#E69F00", "#56B4E9", "#009E73", "#F0E442", "#0072B2", "#D55E00", "#CC79A7"]);



      vis.append("rect")
      .attr("width", w)
      .attr("height", h)
      .style("fill", "none")
      .style("pointer-events", "all")
      .attr("transform", "translate("+20+"," + 0 + ")");


      var box = vis.append('g')
        .style('height',300)
        .style('width', 100)

      var tips = vis.append('g')
        .style('height',300)
        .style('width', 100)


      // makes event circle if event is only one year


      var timeShapes = box.selectAll('.timeShapes').data(events).enter()


        timeShapes
         .filter(function(d) {return d.startDate != d.endDate})
         .append('rect')
        .attr('id', function(d) {return d.name})
        .attr('x', function(d) {return timeScale(d.startDate)})
        .attr('y', function(d) {return (h - 130) - (d.row * 30);})
        .attr('width', function(d) {return (800 * (d.endDate - d.startDate))/ (latestDate - earliestDate)})
        .attr('height', 20)
        .style('fill', function (d) {return locationColor(d.location);})
        .on('click', function() {
          hideTips(rectTips,timeShapes.nodes().indexOf(this));
        });

      timeShapes
        .filter(function (d) {return d.startDate.toDateString() == d.endDate.toDateString()})
        .append('circle')
        .attr('id', function (d) {return d.name})
        .attr('cx', function (d) {return timeScale(d.startDate)})
        .attr('cy', function(d) {return (h - 130) - (d.row * 30);})
        .attr('r', 10)
        .style('fill', function (d) {return locationColor(d.location);})
        .on('click', function(d,i) {
          hideTips(rectTips,timeShapes.nodes().indexOf(i));
        });

      // makes event rectangle if event is more than a year

        function hideTips(d, index){
            rectTips
            .each(function(d,i){
              if(i == index){
                d3.select(this).style('opacity', function(){ if((d3.select(this).style("opacity") != 0)) {return 0}
                                             if((d3.select(this).style("opacity") == 0)) {return .5}

                                                          })
              }
            });

            textLine1
            .each(function(d,i){
              if(i == index){
                d3.select(this).style('opacity', function(){ if((d3.select(this).style("opacity") != 0)) {return 0}
                                             if((d3.select(this).style("opacity") == 0)) {return 1}

                                                          })
              }
            });

            textLine2
            .each(function(d,i){
              if(i == index){
                d3.select(this).style('opacity', function(){ if((d3.select(this).style("opacity") != 0)) {return 0}
                                             if((d3.select(this).style("opacity") == 0)) {return 1}

                                                          })
              }
            });

            textLine3
            .each(function(d,i){
              if(i == index){
                d3.select(this).style('opacity', function(){ if((d3.select(this).style("opacity") != 0)) {return 0}
                                             if((d3.select(this).style("opacity") == 0)) {return 1}

                                                          })
              }
            });
            lines
            .each(function(d,i){
              if(i == index){
                d3.select(this).style('opacity', function(){ if((d3.select(this).style("opacity") != 0)) {return 0}
                                             if((d3.select(this).style("opacity") == 0)) {return 1}

                                                          })
              }
            });

        }

        const rectTips = tips.selectAll('rect').data(events).enter()
        .append('rect')
        .attr('id', function(d) {return d.name})
        .attr('x', function (d, i) { if(i <= 6) { return 825} else {return 0}})
        .attr('y', function(d,i) { if (i<=6) {return i * 70} if(i <=9){return (i - 6)*70 - 70} else {return ((i - 6)*70 + 30)}})
        .attr('width', 150 )
        .attr('height', 60)
        .style('fill', function (d) {return locationColor(d.location);})
        .style('opacity', .5)
        ;

         var lines = tips.selectAll('line').data(events).enter()
           .append('line')
            .style("stroke", function (d) {return locationColor(d.location)})
            .style("stroke-width", 5)
            .attr("x1", function(d,i) {if(i <= 6 && ((earliestDate - latestDate) != 0 )) {return timeScale(d.startDate) +  (800 * (d.endDate - d.startDate))/ (latestDate - earliestDate)}
                                      else if(i <= 6 && ((earliestDate - latestDate) == 0 )) {return timeScale(d.startDate) }
                                      else {return 150}})
            .attr('y1', function(d,i) { if(i <= 6){return ((h - 130) - (d.row * 30))} if(i <=9 && i > 6){return (i - 6)*70 - 70} else {return ((i - 6)*70 + 30)}})
            .attr("x2", function(d,i) {if(i<=6) {return 825} else{return timeScale(d.startDate) }})
            .attr('y2', function(d,i) {if(i<=6){return i * 70} else{return (h - 130) - (d.row * 30) + 10}})
            .style("stroke-dasharray", ("2, 10"));

        const textLine1 = tips.selectAll('text').data(events).enter().append("text")
          .attr('x', function (d, i) { if(i <= 6) {return 820} else {return 0}})
          .attr('y', function(d,i) { if (i<=6) {return i * 70} if(i <=9){return (i - 6)*70 - 70} else {return ((i - 6)*70 + 30)}})
          .attr("dy", "1em")
          .attr("dx", ".35em")
          .text(function(d) { return d.name ;});

         const timeFormat = d3.timeFormat("%B %d, %Y");

          const textLine2 = tips.selectAll('date').data(events).enter().append("text")
          .attr('x', function (d, i) { if(i <= 6) {return 820} else {return 0}})
          .attr('y', function(d,i) { if (i<=6) {return i * 70} if(i <=9){return (i - 6)*70 - 70} else {return ((i - 6)*70 + 30)}})
          .attr("dy", "2em")
          .attr("dx", ".35em")
          .text((function(d) { return timeFormat(d.startDate) ;}));

          const textLine3 = tips.selectAll('date').data(events).enter().append("text")
          .attr('x', function (d, i) { if(i <= 6) {return 820} else {return 0}})
          .attr('y', function(d,i) { if (i<=6) {return i * 70} if(i <=9){return (i - 6)*70 - 70} else {return ((i - 6)*70 + 30)}})
          .attr("dy", "3em")
          .attr("dx", ".35em")
          .text((function(d) { return timeFormat(d.endDate);}));








      var time_axisReg = d3.axisBottom(timeScale)
                   .tickSize(20);

    var zoom = d3.zoom()
    .scaleExtent([-Infinity, Infinity])
    .translateExtent([[-3000, -2000], [w + 3000, h + 2000]])
    .on("zoom", zoomed);

    var gX = vis.append("g")
    .attr("class", "axis axis--x")
    .attr("transform", "translate(0,250)")
    .call(time_axisReg);

    vis.call(zoom);

    function zoomed(event) {
      box.attr("transform", event.transform);
      vis.select('g').attr("transform", event.transform)
      gX.call(time_axisReg.scale(event.transform.rescaleX(timeScale)));

      lines
      .attr('x1', function(d, i) {if(i <=6 && ((earliestDate - latestDate) != 0 )){return (timeScale(d.startDate) + (800 * (d.endDate - d.startDate))/ (latestDate - earliestDate)) * event.transform.k + (event.transform.x ) }
                                  else if(i <= 6 && ((earliestDate - latestDate) == 0 )) {return timeScale(d.startDate) + event.transform.k + (event.transform.x )}
                                  else{return 150}})
      .attr('y1', function(d, i) {if(i <= 6){return ((h - 130) - (d.row * 30))*event.transform.k + event.transform.y + 10}
                                    if(i <=9){return (i - 6)*70 - 70} else {return ((i - 6)*70 + 30)}})
      .attr('y2', function(d,i) {if(i <= 6) {return i * 70} else {return ((h - 130) - (d.row * 30))*event.transform.k + event.transform.y + 10}})
      .attr('x2', function(d, i) {if(i <=6){return 825}
                                  else{return timeScale(d.startDate)* event.transform.k + (event.transform.x )}})

    }


    }
  }
};
</script>

<style scoped>

.timeline {
  width: 100%;
  overflow-x: hidden;
}

.time_axisReg{
  bottom: 0;
}

.axis path {
  display: none;
}

.axis line {
  stroke-opacity: 0.3;
  shape-rendering: crispEdges;
}

.view {
  fill: url(#gradient);
  stroke: #000;
}

.vis{
  overflow-x: hidden;
}

.hidden{
  opacity: 0;
}


</style>
